<template>
  <div class="container lg:mt-8 md:mt-8 mt-0">
    <div class="">
      <div class="absolute bg-design-medc mob-hidden">
        <img
          src="../../../assets/images/bg-des/bgd6.svg"
          alt="bg-polygon"
          class="h-full"
        />
      </div>
      <div class="bg-design-medc-dots absolute mob-hidden">
        <img
          src="../../../assets/images/caregiver/medc-dots.svg"
          alt="bg-polygon"
          class="h-full"
        />
      </div>
      <div class="bg-design-mc-ecli absolute mob-hidden">
        <img
          src="../../../assets/images/caregiver/ecli.svg"
          alt="bg-polygon"
          class="h-full"
        />
      </div>
      <div
        class="relative w-full mx-auto md:pb-12 lg:pb-12 pb-0 lg:pt-0 md:pt-0 pt-8"
      >
        <div
          class="grid md:grid-cols-2 lg:grid-cols-2 grid-cols-1 grid-rows-2 md:gap-10 lg:gap-10 gap-4 md:pt-10 lg:pt-10 pt-6"
        >
          <div
            class="md:p-6 lg:p-6 p-4 card2bg md:rounded-full lg:rounded-full rounded-lg cursor-pointer relative flex"
            @click="toggleDetails(true, item)"
            v-for="(item, index) in cards"
            :key="index"
            :style="{ 'background-color': item.color }"
          >
            <div class="">
              <p class="pt-6 mc-title fsize20-14px">
                {{ item.text }}
              </p>
              <p
                class="pt-2 mc-subtitle ellipsis-4 fsize18-14px cursor-pointer"
              >
                {{ item.description }}
              </p>
            </div>
            <!-- <img
              :src="item.img"
              class="w-full m-auto md:h-40 lg:h-40 h-24"
              alt="medical condition"
            /> -->
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  components: {},
  data() {
    return {
      selectedMedical: {},
      isDetailsActive: false,
      cards: [
        {
          id: "01",
          text: "Caring is often invisible",
          // description:
          //   "All our societies rely on families to care for people who cannot manage alone; however, carers often feel unrecognised. ",
          description:
            "The invaluable act of caring is commonly gone unseen or unnoticed. Across all societies rely on families to care for individuals who may not be able to manage alone. However, Caregivers may often feel unrecognised.",
          img: require("../../../assets/images/caregiver/med-c1.svg"),
          color: "#e3ceff66",
        },
        {
          id: "02",
          text: "Forge new perceptions",
          // description:
          //   "Cancer diagnosis causes complex feelings and lifestyle changes that can be overwhelming for families. The needs and requirements of caregiving for a cancer patient can vary depending on the type. It is emotionally and financially draining for the majority, especially when it involves palliative care. Our advisory services on financial planning, respite care and home-based care offers you opportunities to create checks and balances for your long-term caregiving needs. ",
          description:
            "Through these contributions, we aim to cultivate fresh perspectives on compassion, joy, and the grace of care, while breaking down stereotypes associated with caregiving.",
          img: require("../../../assets/images/caregiver/med-c2.svg"),
          color: "#e3ceff66",
        },
        {
          id: "03",
          text: "Recognise the challenges",
          // description:
          //   "We also want to recognise and honour the challenges necessary in caring and invite carers to offer us images that demonstrate how we maintain a balance between care giving and self care, working and caring, duty and love.",
          description:
            "We seek to recognize and celebrate the challenges necessary in caregiving. By showcasing the ability to strike a balance between giving care and practicing self-care, and embracing the harmonious blend of duty and love.",
          img: require("../../../assets/images/caregiver/med-c3.svg"),
          color: "#e3ceff66",
        },
        {
          id: "04",
          // text: "Respond to the videos",
          text: "Respond to the shared work",
          // description:
          //   "In the pages that follow we invite you to respond to the videos made in partnership with carers and upload your own images of care to our digital gallery. ",
          description:
            "In the pages that follow we invite you to respond to the videos made in partnership with Caregivers and upload your own images of care to our digital gallery.",
          img: require("../../../assets/images/caregiver/med-c4.svg"),
          color: "#e3ceff66",
        },
      ],
    };
  },
  methods: {
    toggleDetails(val = false, item = {}) {
      this.isDetailsActive = val;
      this.selectedMedical = item;
    },
    handleregister() {
      this.$router.push({ name: "register" });
    },
  },
};
</script>
